import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { SupportRequest } from '@type/user'

const createSupport = (data: SupportRequest): Promise<SupportRequest> => {
  return new Promise((resolve, reject) => {
    const URL = routes.BASE + '/api/support/requests'
    // const config = {
    //     headers: {
    //         Authorization: `Bearer ${token}`,
    //     },
    // }
    AxiosClient.post(URL, data)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
export default createSupport
